module.exports = __webpack_public_path__ + "img/LoPresti.b04d9a81.png";